<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="球杆解绑"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <!-- 独立的背景图区域 -->
      <div class="bg-card">
        <img src="@/assets/img/h5/unbind.png" alt="背景图" class="bg-img" />
      </div>

      <!-- 新增：解绑主要提示文字 -->
<!--      <div class="main-tip">仅支持会员退货解绑</div>-->

      <!-- 独立的文本框区域（放在背景图下方） -->
      <div class="form-card">
        <!-- 球杆编码输入框 -->
        <van-field
            v-model="number"
            name="number"
            label="球杆编码"
            placeholder="请输入球杆编码"
            class="form-input number-input"
            required
            @blur="trimNumber"
        />
        <!-- 解绑原因 textarea 文本框 -->
        <van-field
            v-model="opinion"
            required
            name="opinion"
            label="解绑原因"
            type="textarea"
            placeholder="请输入解绑原因"
            class="form-input reason-input"
            rows="3"
            @blur="trimOpinion"
        />

        <van-field name="fileList" required label="上传凭证" class="checktype-img" :rules="[{ required: true, message: '请上传问题图片' }]">
          <template #input>
            <van-uploader v-model="fileList" multiple  accept="image/*,video/*" :max-count="6" />
          </template>
        </van-field>
      </div>

      <!-- 解绑按钮（在文本框下方） -->
      <van-button class="search-btn" block @click="getProgress">解绑</van-button>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { unbindByNumber } from "@/api/sales";
import { Dialog, Toast, Uploader } from "vant";

export default {
  components: {
    [Uploader.name]: Uploader
  },
  data() {
    return {
      number: '', // 球杆编码
      opinion: '', // 解绑原因
      fileList: [], // 上传文件列表
    }
  },
  methods: {
    // 顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },

    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
        // PC端弹窗适配
        style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
      });
    },

    // 球杆编码去空格
    trimNumber() {
      this.number = this.number.trim();
    },
    // 解绑原因去空格
    trimOpinion() {
      this.opinion = this.opinion.trim();
    },
    // 球杆解绑（解绑原因非空校验）
    getProgress() {
      this.trimNumber(); // 球杆编码去空格
      this.trimOpinion(); // 解绑原因去空格

      // 1. 校验球杆编码
      if (!this.number) {
        Toast('请输入球杆编码');
        return;
      }
      // 2. 校验解绑原因
      if (!this.opinion) {
        Toast('请输入解绑原因');
        return;
      }
      // 3. 校验上传文件
      if (this.fileList.length === 0) {
        Toast('请上传解绑凭证文件');
        return;
      }

      // 确认弹窗（PC端适配）
      Dialog.confirm({
        title: '确认解绑',
        message: '是否确认解绑该球杆？解绑后将解除该球杆编码的绑定关系，请谨慎操作！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
      }).then(() => {
        this.doUnbind();
      }).catch(() => {
      });
    },
    // 解绑核心逻辑（传递解绑原因参数和文件）
    async doUnbind() {
      // 创建FormData对象，用于上传文件和参数
      const formData = new FormData();

      // 添加普通参数
      formData.append('keyWord', this.number);
      formData.append('opinion', this.opinion);

      const files = [];
      this.fileList.forEach(item => {
        if (item.file) {
          files.push(item.file);
          formData.append('multipart', item.file);
        }
      });

      try {
        // 注意：这里需要修改axios请求配置，使用form-data格式上传
        const res = await unbindByNumber(formData);
        if (res.code === 200) {
          this.showDialogMsg(res.returnMsg || '球杆解绑成功！');
          // 解绑成功后清空所有输入和文件
          this.number = '';
          this.opinion = '';
          this.fileList = [];
        } else {
          this.showDialogMsg(res.returnMsg || '球杆解绑失败，请稍后重试');
        }
      } catch (err) {
        this.showDialogMsg('网络异常，解绑失败，请稍后重试');
        console.error('解绑失败：', err);
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 继承公共样式的黑金主题色变量
$black: #000000;
$gold: #D4AF37;
$dark-gold: #B8860B;

::v-deep .van-field{
  margin-bottom: 0 !important;
}
// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
  // PC端导航栏箭头适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
  // PC端返回文字适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
.top-bar {
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  // PC端导航栏整体适配
  @media (min-width: 768px) {
    height: 70px !important;
    ::v-deep .van-nav-bar__title {
      font-size: 30px !important;
      line-height: 70px !important;
    }
  }
}

// 整体容器（核心：PC端50%宽度居中）
.h5-container {
  @media (min-width: 768px) {
    width: 50%;
    margin: 0 auto;
    min-height: 110vh;
    box-sizing: border-box;
    background-color: #1a1a1a;
  }
}
.container-item {
  padding: 0 16px;
  margin-bottom: 60px;
  // PC端容器适配
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 42px;
  }
}

// 独立背景图区域
.bg-card {
  margin: 16px 0;
  border-radius: 12px;
  overflow: hidden; // 防止图片超出圆角
  border: 2px solid $dark-gold;
  box-sizing: border-box;
  // PC端背景图容器适配
  @media (min-width: 768px) {
    height: 400px;
    border-radius: 12px;
    margin: 20px auto;
    border-width: 2px; // 加粗边框
  }
}
.bg-img {
  width: 100%;
  height: auto; // 自适应高度，保持图片比例
  display: block; // 去掉图片默认间隙
  // PC端背景图适配
  @media (min-width: 768px) {
    min-height: 400px; // 限制最大高度，保证比例
    object-fit: cover; // 保持图片比例
  }
}

// 新增：主要提示文字样式
.main-tip {
  text-align: center;
  color: $dark-gold;
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 12px;
  line-height: 1.4;
  // PC端提示文字适配
  @media (min-width: 768px) {
    font-size: 20px;
    margin: 0 0 20px;
    font-weight: 600;
  }
}

// 独立文本框区域
.form-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  // PC端表单容器适配
  @media (min-width: 768px) {
    padding: 25px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
}
.form-input {
  border-radius: 10px;
  border-bottom: none;
  background: #f8f8f8;
  // PC端输入框基础适配
  @media (min-width: 768px) {
    --van-field-font-size: 18px;
    height: 50px;
    min-height: 50px;
    line-height: 50px;
    padding: 0 15px;
    border-radius: 12px;
  }
}
.number-input {
  margin-bottom: 15px; // 编码和原因输入框之间的间距
  // PC端编码输入框适配
  @media (min-width: 768px) {
    margin-bottom: 20px;
    ::v-deep .van-field__label {
      width: 80px;
      font-size: 18px;
      line-height: 50px;
    }
    ::v-deep .van-field__control {
      font-size: 18px;
      height: 50px;
      line-height: 50px;
    }
  }
}
.reason-input {
  background: #f8f8f8;
  // PC端textarea适配
  @media (min-width: 768px) {
    height: auto !important;
    min-height: 120px;
    ::v-deep .van-field__label {
      width: 80px;
      font-size: 18px;
      line-height: 1.5;
      margin-bottom: 5px;
    }
    ::v-deep .van-field__control {
      font-size: 18px;
      min-height: 100px;
      padding: 10px 15px;
      line-height: 1.5;
    }
  }
}

// 解绑按钮样式
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  color: $black;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  // PC端按钮适配
  @media (min-width: 768px) {
    height: 80px;
    font-size: 36px;
    border-radius: 12px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    &:hover {
      background: $dark-gold;
      cursor: pointer;
    }
  }
}

// 弹窗按钮样式适配
::v-deep .van-dialog__confirm {
  color: $dark-gold !important;
  // PC端弹窗按钮适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__cancel {
  // PC端弹窗取消按钮适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__title {
  // PC端弹窗标题适配
  @media (min-width: 768px) {
    font-size: 24px !important;
    margin-bottom: 15px !important;
  }
}
::v-deep .van-dialog__message {
  // PC端弹窗内容适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    line-height: 1.6 !important;
  }
}

// Toast提示PC端适配
::v-deep .van-toast {
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 15px 25px !important;
    border-radius: 10px !important;
  }
}
// ################### 核心修复：PC端预览图超界问题 ###################
.checktype-img {
  @media (min-width: 768px) {
    // 1. 基础容器适配：保证高度+不溢出
    min-height: 150px !important;
    height: auto !important;
    padding: 10px 0 !important;
    overflow: visible !important;

    // 2. 字段内容区适配
    ::v-deep .van-field__control {
      height: auto !important;
      min-height: 130px;
      padding: 0 !important;
      width: 100% !important; // 强制占满容器宽度
      box-sizing: border-box !important;
    }

    // 3. Uploader容器：横向滚动+尺寸控制（核心解决超界）
    ::v-deep .van-uploader {
      width: 100% !important;
      padding: 10px 0;
      display: flex !important;
      flex-wrap: nowrap !important; // 强制单行
      overflow-x: auto !important; // 横向滚动，不超界
      overflow-y: hidden !important;
      gap: 10px !important; // 统一间距，替代margin
      box-sizing: border-box !important;
      scrollbar-width: thin; // 美化滚动条（Firefox）

      // 滚动条样式优化（Chrome/Safari）
      &::-webkit-scrollbar {
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $gold;
        border-radius: 3px;
      }

      // 4. 上传按钮：缩小尺寸适配容器
      .van-uploader__upload {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩
        margin: 0 !important; // 取消margin，用gap控制间距
        font-size: 14px !important;
      }

      // 5. 预览图：缩小尺寸+禁止压缩
      .van-uploader__preview {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important; // 禁止压缩，避免变形
        margin: 0 !important; // 取消margin，用gap控制间距
        position: relative;
      }
      .van-uploader__preview-image{
        width: 100px !important;
        height: 100px !important;
      }

      // 6. 预览图删除按钮：适配缩小后的预览图
      .van-uploader__preview-delete {
        width: 20px !important;
        height: 20px !important;
        font-size: 12px !important;
        top: 5px;
        right: 5px;
      }
    }
  }
}

// 移动端保持原有逻辑（不影响）
::v-deep .van-uploader {
  @media (max-width: 767px) {
    flex-wrap: wrap !important;
    overflow-x: visible !important;
  }
}

::v-deep .van-uploader__preview-delete-icon{

  @media (min-width: 768px) {
    font-size: 35px !important;
  }
}
// ###########################################################

</style>